import endpoints from '../endpoints.ts';
import { Toast } from '../types/models';
import { fetch } from './helpers.ts';

const settings = {
  create: {
    one: {
      dataExport: async (params: {
        customerLocationId: number | string;
        startDate?: string;
        endDate?: string;
      }): Promise<Toast | null> => {
        const url = endpoints.settings.create.one.dataExport();
        return await fetch<Toast>(url, 'GET', params);
      },
    },
  },
};

export default settings;
